export default __webpack_public_path__ + "static/media/23.df66501e.png";